"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cubicInOut = exports.cubicOut = exports.cubicIn = exports.quadraticInOut = exports.quadraticOut = exports.quadraticIn = exports.linear = void 0;
/**
 * Sigma.js Easings
 * =================
 *
 * Handy collection of easing functions.
 */
exports.linear = function (k) { return k; };
exports.quadraticIn = function (k) { return k * k; };
exports.quadraticOut = function (k) { return k * (2 - k); };
exports.quadraticInOut = function (k) {
    if ((k *= 2) < 1)
        return 0.5 * k * k;
    return -0.5 * (--k * (k - 2) - 1);
};
exports.cubicIn = function (k) { return k * k * k; };
exports.cubicOut = function (k) { return --k * k * k + 1; };
exports.cubicInOut = function (k) {
    if ((k *= 2) < 1)
        return 0.5 * k * k * k;
    return 0.5 * ((k -= 2) * k * k + 2);
};
